var map = {
	"./avatar.jpg": 2873,
	"./footer-hr-removebg-preview.png": 1245,
	"./footer-hr.png": 7408,
	"./head/834926.png": 5647,
	"./head/banner2.png": 1893,
	"./head/bg-img.jpeg": 3051,
	"./head/doge.jpg": 7974,
	"./hr-jeronimo-strehl-02-removebg-preview.png": 317,
	"./hr-tree-ardy-removebg-preview.png": 8199,
	"./mikus-post-bg/miku1.jpg": 2286,
	"./mikus-post-bg/miku2.jpg": 8425,
	"./mikus-post-bg/miku3.jpg": 1052,
	"./mikus-post-bg/miku4.jpg": 8487,
	"./mikus-post-bg/other.jpg": 7187,
	"./post-bg-default.jpg": 8806,
	"./post-bg.jpg": 1642,
	"./post-bg1.jpg": 4501
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9548;